import React from 'react'

const Anchor = ({
  data: { id, className = '' }
}: {
  data: { id: string; className?: string }
}) => <div id={id} className={className} />

export default Anchor
